import { jsx as _jsx } from "react/jsx-runtime";
import { Orientation } from '../../Constants/System';
import { useLayoutEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { CombineClasses } from '../../Utility/ReactUtils';
export default function EvenGrid(props) {
    const orientation = props.orientation ?? Orientation.horizontal;
    const [count, setCount] = useState(0);
    const ref = useRef(null);
    useLayoutEffect(() => {
        if (ref && ref.current) {
            setCount(ref.current.children.length);
        }
    }, [ref, props.children]);
    const className = CombineClasses(props.className, 'even-grid');
    return (_jsx(StyledEvenGrid, { "$count": count, "$orientation": orientation, className: className, ref: ref, children: props.children }));
}
const GridTemplateCssAttributeMap = {
    HORIZONTAL: 'grid-template-columns',
    VERTICAL: 'grid-template-rows',
};
const StyledEvenGrid = styled.div `
	display: grid;
	${(props) => `${GridTemplateCssAttributeMap[props.$orientation]}: repeat(${props.$count}, 1fr)`};
`;
//# sourceMappingURL=EvenGrid.js.map